// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__YBl74","rootCenter":"LoadMoreObserver_rootCenter__3BlIf","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3sep6"};